var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"water-eval-container"},[_c('div',{staticClass:"cityGreenLand-charts",style:(`width:${_vm.width};height:${_vm.height}px`),attrs:{"id":"cityGreenLand-charts"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }